import { type FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { type Auth, connectAuthEmulator, getAuth } from 'firebase/auth';

// Firebase config is injected via Vite environment variables.
// Each app's .env file must define these variables.
// See .env.example for the required keys.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
};

// Avoid re-initializing the app when module is hot-reloaded in dev.
// isNewApp is true on the first module load and false on HMR reloads
// (where getApps() already returns the initialized instance).
const isNewApp = getApps().length === 0;
export const firebaseApp: FirebaseApp = isNewApp ? initializeApp(firebaseConfig) : getApp();
export const auth: Auth = getAuth(firebaseApp);

// Connect to the local Auth emulator when VITE_FIREBASE_USE_EMULATOR=true.
// Guard with isNewApp so this is only called once — connectAuthEmulator throws
// if called a second time on the same Auth instance (which happens on HMR).
if (isNewApp && import.meta.env.VITE_FIREBASE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}
